<template>
	<div class="tab-content">
		<h3 class="font-weight-bold">Add New Instructor</h3>
		<div>
			<form onkeypress="return event.keyCode != 13;">
				<div class="form-group">
					<label>Name</label>
					<input type="name" name="name" class="form-control" v-model="name" v-on:keyup.enter="add">
					<p class="text-right my-2">
						<button type="button" class="btn btn-primary" v-on:click="add()">Add</button>
					</p>
				</div>
			</form>
		</div>
		<div class="tab-pane fade show active" v-if="!loading">
			<form class="py-3 text-right">
			<div>
				<input class="border shadow-none p-2 col-6 " type="text" placeholder="Find instructor" v-on:keyup="searchFunction" v-model="input">
				<i class="fas fa-search"></i>
			</div>
			</form>

			<table class="table table-bordered m-0">
			<thead class="bg-light">
				<tr>
					<th class="text-center" scope="col">No</th>
					<th class="text-center" scope="col">Name</th>
					<th class="text-center" scope="col">Action</th>
				</tr>
			</thead>
			<tbody ref="myTable">
				<tr class="p-0" v-for="(instructor, i) in instructors" v-bind:key="i" v-if="instructor" ref="tr">
					<td class="text-center">{{i+1}}</td>
					<td ref="td">{{instructor.name}}</td>
					<td class="text-center"><button class="btn btn-danger" @click="deleteInstructor(instructor.id)">Delete</button></td>
				</tr>
			</tbody>
			</table>
			
			<div class="d-flex my-2 justify-content-between">
				<div>
					<button class="btn btn-primary" v-on:click="Previous" v-if="page >= 2">Previous</button>
				</div>
				<div>
					<button class="btn btn-primary" v-on:click="next">Next</button>
				</div>
				
			</div>

		</div>
		<div v-else>
			<div class="d-flex justify-content-center">
				<div class="py-5" v-if="loading">
					<div class="loader"></div>
				</div>
			</div>
		</div>

		<hr>
		
		<!-- Add Instructor -->
		
	</div>
</template>
<script>
	import axios from 'axios'
	import App from '@/App'

	export default {
		data() {
			return {
				url: App.data().url,
				loading: true,
				input: '',
				name: '',
				page : 1,
				instructors: [
					{
						name: ""
					}
				]
			}
		},
		mounted() {
			var pathQuery = '?' + 'page' + '=' + this.$route.query.page + '&' + 'size' + '=' + this.$route.query.size

			axios.get(this.url.limitInstructor + pathQuery).then((res) => {
				if(res.status === 200){
					this.instructors = res.data.result
				}
			})
			.catch(err => {
				alert('Error');
			})
			.then(() => {
				this.loading = false;
			})
		},
		methods: {
			deleteInstructor(data){
				console.log("YANG MAU DI HAPUS", data)
				App.methods.deleteData(this.url.instructor + '/' + data, () => {
				});
			},
			searchFunction(){
				var input = this.input;
				var filter = input.toUpperCase();
				// var table =  this.$refs.myTable;
				var tr = this.$refs.tr;

				for (var i = 0; i < tr.length; i++) {
					var td = tr[i].getElementsByTagName("td")[1];
					if (td) {
						var txtValue = td.textContent || td.innerText;
						if (txtValue.toUpperCase().indexOf(filter) > -1) {
							tr[i].style.display = "";
					} else {
						tr[i].style.display = "none";
						}
					}       
				}
			},
			add(){
				if(this.name == ''){
					alert("Nama instructor belum di mengisi. Harap isi terlebih dahulu")
				}else {
					App.methods.postData(this.url.instructor, {name: this.name}, ()=>{
						console.log('ok')
					})
				}
			},
			next() {

				this.page++
				this.$router.replace({
					name: 'instructor', query: {page: + this.page ,size: 10}
				})
				var pathQuery = '?' + 'page' + '=' + this.$route.query.page + '&' + 'size' + '=' + this.$route.query.size

				axios.get(this.url.limitInstructor + pathQuery).then((res) => {
					if(res.status === 200){
						this.instructors = res.data.result
					}
				})
				.catch(err => {
					alert('Error');
				})
				.then(() => {
					this.loading = false;
				})
			},
			Previous(){
				

				if(this.page > 1){
					this.page--
					this.$router.replace({
						name: 'instructor', query: {page:  + this.page, size: 10}
					})
				}

				var pathQuery = '?' + 'page' + '=' + this.$route.query.page + '&' + 'size' + '=' + this.$route.query.size

				axios.get(this.url.limitInstructor + pathQuery).then((res) => {
					if(res.status === 200){
						this.instructors = res.data.result
					}
				})
				.catch(err => {
					alert('Error');
				})
				.then(() => {
					this.loading = false;
				})
			}
		}
	}
</script>
<style scoped>
	.loader {
		border: 12px solid #f3f3f3;
		border-radius: 50%;
		border-top: 12px solid #000000;
		/*border-bottom: 15px solid #007bff;*/
		width: 100px;
		height: 100px;
		-webkit-animation: spin 2s linear infinite; /* Safari */
		animation: spin 2s linear infinite;

	}

	/* Safari */
	@-webkit-keyframes spin {
		0% { -webkit-transform: rotate(0deg); }
		100% { -webkit-transform: rotate(360deg); }
	}

	@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}
</style>